import './index.scss';

const PageDescription = ({ label, className = '', children, ...rest }) => (children || label) && (
    <p className={`page-description ${className}`} {...rest}>
        {children || label}
    </p>
);

export default PageDescription;
